export default {"src":"/oferta/_next/static/media/youtube.bc649b8b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};